(function () {
	'use strict';

	ModuleSwitcherCmpController.$inject = [
		'$rootScope',
		'$scope',
		'$state',
		'$log',
		'$window',
		'UserService',
	];
	function ModuleSwitcherCmpController(
		$rootScope,
		$scope,
		$state,
		$log,
		$window,
		UserService
	) {
		const vm = this;
		let otherModules = [];
		let modulesFromBackend = [];

		vm.$onInit = onInit;
		vm.switchTo = switchTo;

		function onInit() {
			initEvents();
			initWatchers();
		}

		function switchTo(module) {
			$log.debug(`go to: ${module.url || module.stateName}`);
			if (module.url !== '' && module.stateName === undefined) {
				$window.open(module.url);
				return;
			}
			$rootScope.$broadcast('isGenericDataMode', !vm.isGenericDataMode);
			$state.go(module.stateName);
		}

		function getInstanceIcon(type) {
			switch (type) {
				case 'DC_CONSOLE':
					return 'src/img/DC-color-solo.svg';
				case 'DC_MARKETPLACE':
					return 'src/img/DCM-color-solo.svg';
				case 'PYDC':
					return 'src/img/pyDc-color.svg';
				case 'DC_CODE':
					return 'src/img/pyDc-color.svg';
				default:
					return '';
			}
		}

		function buildAvailableLinks(isInGenericsMode) {
			if (isInGenericsMode) {
				return [
					{
						img: 'src/img/handleData-color-solo.svg',
						label: 'Handle Data',
						stateName: 'home',
					},
					...otherModules,
				];
			}
			return [
				{
					img: 'src/img/genericsData-color-solo.svg',
					label: 'Generics Data',
					stateName: 'gd-home',
				},
				...otherModules,
			];
		}

		function initEvents() {
			UserService.getAvailableInstanceModules().then(function (response) {
				for (let i in response.data) {
					let item = response.data[i];
					modulesFromBackend.push({
						img: getInstanceIcon(item['type']),
						label: item['label'],
						stateName: undefined,
						url: item['public_url'],
					});
				}
				otherModules = modulesFromBackend;
				vm.availableModules = buildAvailableLinks(vm.isInGenericsMod);
			});

			$scope.$on('project:link-update', function (event, val) {
				console.log('project:link-update');
				const [first, ...others] = vm.availableModules;
				if (val === '' || val === undefined || val === null) {
					otherModules = modulesFromBackend;
					vm.availableModules = [first, ...otherModules];
					return;
				}
				otherModules = [
					{
						img: 'src/img/pyDc-color.svg',
						label: 'PyDc',
						stateName: undefined,
						url: val,
					},
					...modulesFromBackend,
				];
				vm.availableModules = [first, ...otherModules];
			});
		}

		function initWatchers() {
			$scope.$watch(
				function () {
					return vm.isInGenericsMod;
				},
				function (newVal, oldVal) {
					vm.isGenericDataMode = newVal;
					if (newVal === oldVal) {
						return;
					}
					otherModules = modulesFromBackend;
					vm.availableModules = buildAvailableLinks(newVal);
				}
			);
		}
	}

	const firstCmp = {
		restrict: 'E',
		bindings: {
			isInGenericsMod: '<',
		},
		controller: ModuleSwitcherCmpController,
		templateUrl:
			'./src/components/directives/module-switcher/module-switcher.component.html',
		controllerAs: 'vm',
	};

	angular.module('dcApp').component('moduleSwitcherCmp', firstCmp);
})();
